import React, { useEffect } from 'react';
import { FaDev, FaMoneyCheckAlt, FaBalanceScale, FaCalendarAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';

const Menu = () => {
  const navigate = useNavigate();
  const { userInfo } = useUser();

  useEffect(() => {
    if (!userInfo.username || !userInfo.company) {
      navigate('/');
    }
  }, [userInfo, navigate]);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <div className="menu-container">
      <header className="header">
        <h2>Bem-vindo, {userInfo.username}!</h2>
      </header>
      <div className="buttons-container">
        <button onClick={() => handleNavigation('/Desenvolvimento')} className="menu-button">
          <FaDev size={30} />
          <span>Lançamentos de OS</span>
        </button>
        <button onClick={() => handleNavigation('/Financeiro')} className="menu-button">
          <FaMoneyCheckAlt size={30} />
          <span>Funções Financeiras</span>
        </button>
        <button onClick={() => handleNavigation('/Grafico')} className="menu-button">
          <FaBalanceScale size={30} />
          <span>Gráficos</span>
          </button>
          <button onClick={() => handleNavigation('/Agenda')} className="menu-button">
          <FaCalendarAlt size={30} />
          <span>Agenda</span>          
        </button>
      </div>
    </div>
  );
};

export default Menu;